import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './LandingPageReviewsSection.module.css';

const StarIcon = ({ filled }) => (
    <svg
        className={filled ? css.starFilled : css.starEmpty}
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
);

const ReviewCard = ({ quoteId, authorId, avatarInitial, rating = 5 }) => (
    <div className={css.card}>
        <div className={css.stars}>
            {[1, 2, 3, 4, 5].map(v => (
                <StarIcon key={v} filled={v <= rating} />
            ))}
        </div>
        <p className={css.quote}>
            “<FormattedMessage id={quoteId} />”
        </p>
        <div className={css.authorInfo}>
            <div className={css.avatar}>{avatarInitial}</div>
            <span className={css.authorName}>
                <FormattedMessage id={authorId} />
            </span>
        </div>
    </div>
);

const LandingPageReviewsSection = props => {
    return (
        <div className={css.root}>
            <h2 className={css.title}>
                <FormattedMessage id="LandingPage.reviewsTitle" />
            </h2>
            <p className={css.subtitle}>
                <FormattedMessage id="LandingPage.reviewsSubtitle" />
            </p>
            <div className={css.reviewsGrid}>
                <ReviewCard
                    quoteId="LandingPage.review1Quote"
                    authorId="LandingPage.review1Author"
                    avatarInitial="A"
                />
                <ReviewCard
                    quoteId="LandingPage.review2Quote"
                    authorId="LandingPage.review2Author"
                    avatarInitial="M"
                />
                <ReviewCard
                    quoteId="LandingPage.review3Quote"
                    authorId="LandingPage.review3Author"
                    avatarInitial="E"
                    rating={4}
                />
            </div>
        </div>
    );
};

export default LandingPageReviewsSection;
